module.exports = __webpack_public_path__ + "assets/226e7ef8d0f07fe49d42b35d8b68c5e5.png";